import React, { useState, useContext, useEffect, useRef } from "react";

import ExportHeader from "./ExportHeader";
import { geteDetailByID } from "../../services/apis";

import CircularProgressBar from "../../utils/CircularProgressBar";
import HTMLPlaceholder from "../../images/HTMLFile.svg";

// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/cjs/Page/AnnotationLayer.css";

export default function MLRPDDF({
  deckData,
  setExportFormats,
  pdfURL,
  setOpenMLRPDF,
}) {
  const [numPages, setNumPages] = useState(null);
  const [pdfWidth, setpdfWidth] = useState(800);
  const [MLR, setMLR] = useState("-");
  const pdfDisplay = useRef();
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showApprovedModal, setShowApprovedModal] = useState(false);
  const [clickOnSubmit, setClickOnSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLength, setPageLength] = useState(9);
  const [defaultNumber, setDefaultName] = useState(0);
  const [mlrData, setMlrData] = useState(null);
  const [previewData, setPreviewData] = useState();

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  } //

  //  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  useEffect(() => {
    setPreviewLoading(true);

    geteDetailByID(deckData.id, (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
      } else {
        if (response.data.veevaMetadata.length > 0)
          setMLR(response.data.veevaMetadata[0]?.htmlNo);
        setMlrData(response.data.veevaMetadata[0]);
        setPreviewLoading(false);
        setPreviewData(response.data);
      }
    });
  }, []);
  const handleApprovedtemplateModal = () => {
    setShowApprovedModal(true);
  };
  const closeApprovedTemplateModal = () => {
    setShowApprovedModal(false);
  };

  const pageListLength = Array.from(new Array(numPages));
  return (
    <>
      {previewLoading && (
        <CircularProgressBar
          isloading={previewLoading}
          setIsloading={setPreviewLoading}
        />
      )}
      <ExportHeader
        handleApprovedtemplateModal={handleApprovedtemplateModal}
        setOpenMLRPDF={setOpenMLRPDF}
        setExportFormats={setExportFormats}
        pdfURL={deckData.pdfURL}
        deckData={deckData}
        setMLR={setMLR}
        loading={loading}
        setLoading={setLoading}
        submitMLR={"test"}
        mlrData={mlrData}
        setPreviewLoading={setPreviewLoading}
        previewData={previewData}
      ></ExportHeader>

      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-8 offset-md-2 mt-1 mb-1">
            <div className="d-flex justify-content-between">
              <div className="section-left">
                <div className="section-items">
                  <span>
                    {previewData?.type == 1 ? "Template Name" : "e-Detail Name"}
                  </span>
                  <p>{deckData.name}</p>
                </div>
                <div className="section-items">
                  <span>Country</span>
                  <p>{deckData.brand}</p>
                </div>
                {/* <div className="section-items">
                  <span>Campaign</span>
                  <p>
                    {deckData.campaign !== "undefined"
                      ? deckData.campaign
                      : "-"}
                  </p>
                </div> */}
                {previewData?.type==0 && <div className="section-items mlr_title">
                  <span>Binder ID</span>
                  <p className="mlrPdfNo">{MLR}</p>
                </div> }
                {previewData?.type==1 && <div className="section-items mlr_title">
                  <span>Template ID</span>
                  <p className="mlrPdfNo">{previewData.veevaMetadata[0]?.pdfNo}</p>
                </div> }
              </div>
              <div className="section-right"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid tempalate-preview">
        <div className=" row pdf-Conatiner">
          <div
            id="pdf-display"
            className="col-md-8 offset-md-2 mt-4 pe-0 ExportRenderContainer"
          >
            <img
              alt="undo"
              src={HTMLPlaceholder}
              width={115}
              // height={24}
              style={{ cursor: "pointer" }}
              className="HTMLPlaceholder"
            />
            <div className="download-Text">Download package to view</div>
          </div>
        </div>
      </div>
    </>
  );
}
